import './MobileGeneralAIAgentPage.css';
import { useTranslation } from 'react-i18next';
import { message as messageApi } from '@icp/settings';
import { AIAgentV2 } from '@icp/components';
import markdownCodeComponents from '../../markdownCodeComponents';
import { handleSave } from '../../markdownCodeComponents/utils';
import { renderPromptText } from '../../GeneralAIAgent';

function MobileGeneralAIAgentPage() {
  const { t } = useTranslation();

  const promptAnswerActions = (msgContent) =>
    [
      /```(icp-table|icp-chart|icp-generic-chart)/.test(msgContent || '') && {
        label: t('save', { ns: 'icp-common' }),
        handlerKey: 'onSave',
      },
    ].filter(Boolean);

  return (
    <div className="mobile-general-ai-agent-container">
      <AIAgentV2
        markdownCodeComponents={markdownCodeComponents}
        eventHandlers={{
          onSave: (msg, question) =>
            handleSave(msg, null, question).then(() => {
              messageApi.success(t('chat.save-portlet-success', { ns: 'default' }));
            }),
          renderPromptText,
        }}
        promptAnswerActions={promptAnswerActions}
      />
    </div>
  );
}

export default MobileGeneralAIAgentPage;
